const isTest = () => {
  var _a;
  return typeof process !== "undefined" && ((_a = process["env"]) == null ? void 0 : _a.NODE_ENV) === "test";
};
const isProd = () => {
  var _a;
  return typeof process !== "undefined" && ((_a = process["env"]) == null ? void 0 : _a.NODE_ENV) === "production";
};
export {
  isProd,
  isTest
};
//# sourceMappingURL=environment.js.map
